import React, { useState } from 'react'
import ListItemCard from '../../../Components/Card/LIstItemCard';
import { phone, mail } from '../../../Helper/svgs';
import ContactInfo from '../../../Data/ContactInfo';
import goToLink from '../../../Helper/GoToLink';

export default function CardsList() {
    const [isPhnActive, setIsPhnActive] = useState(false);
    const [isMailActive, setIsMailActive] = useState(false);
    return (
        <div className='container-vertical res-gap-8'>
            <ListItemCard
                icon={phone()}
                title={ContactInfo.phone}
                isActive={isPhnActive}
                onMouseEnter={() => setIsPhnActive(true)}
                onMouseLeave={() => setIsPhnActive(false)}
                onClick={()=> goToLink(`tel:${ContactInfo.phone}`)}
                />
            <ListItemCard
                icon={mail()}
                title={ContactInfo.email}
                isActive={isMailActive}
                onMouseEnter={() => setIsMailActive(true)}
                onMouseLeave={() => setIsMailActive(false)}
                onClick={()=> goToLink(`mailto:${ContactInfo.email}`)}
             />
        </div>
    )
}
